import moment from "moment";
import { STATUS } from "../enums/Type";

export const formatReportApprovalDate = (
  approvedDate: string | null | undefined,
  status: string,
): string => {
  if (
    status === STATUS.OnHOLD ||
    !approvedDate ||
    approvedDate.startsWith("0001-01-01T00:00:00")
  ) {
    return "";
  }

  return moment(approvedDate).format("MMM DD,YYYY hh:mm A");
};

export const FormatNumber = (number: number): string => {
  return `${number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
};

export const Formatter = (number: number): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear().toString().padStart(4, "0");
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getCurrentLastDateOfTheMonth = () => {
  const currentDate = new Date();
  const lastDateOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1
  );
  const formattedDate = lastDateOfMonth.toISOString().split("T")[0];
  return formattedDate;
};

export const lower1stLetter = (str: string) => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

export const contactNumberChecker = (number: string) => {
  return number.replace(/[-()]/g, "");
};

export const middleNameChecker = (middleName: string) => {
  return middleName.replace(/./g, "");
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatReportDate = (dateString: string) => {
  const date = new Date(dateString);

  const pad = (num: number) => (num < 10 ? `0${num}` : num);

  const day = pad(date.getUTCDate());
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};

export const formatDateTimeUS = (date: Date) => {
  const pad = (num: number) => (num < 10 ? `0${num}` : num);

  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1);
  const year = date.getFullYear();

  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getApprovalStatusStyle = (status: string) => {
  switch (status) {
    case "PENDING":
      return { color: "orange", fontWeight: "bold" };
    case "FAILED":
      return { color: "red", fontWeight: "bold" };
    case "AVAILABLE":
      return { color: "green", fontWeight: "bold" };
    default:
      return {};
  }
};

export const getApprovalTotalAmountStyle = (amount: string) => {
  return { color: "black", fontWeight: "bold" };
};
